import React from "react";

const Textarea = ({ value, name, onChange, onBlur, label, labelFor, placeholder, isRequired = false, rows = 4, error, disabled = false, showRequiredIndicator = true }) => {
    return (
        <div className="mb-4">
            {label && (
                <label
                    htmlFor={labelFor}
                    className="text-sm font-bold block text-fontColor dark:text-[#c9d1d9] mb-2"
                >
                    {label} {isRequired && showRequiredIndicator && <span className="text-red-500 dark:text-red-400">*</span>}
                </label>
            )}
            <div className="relative w-full">
                <textarea
                    id={labelFor}
                    name={name}
                    onChange={onChange}
                    onBlur={onBlur}
                    value={value || ''}
                    placeholder={placeholder}
                    rows={rows}
                    disabled={disabled}
                    className={`w-full h-[100px] px-4 py-2 bg-white dark:bg-[#0d1117] text-gray-900 dark:text-[#c9d1d9] text-sm font-normal text-[14px] border rounded-md focus:outline-none focus:ring-2 focus:ring-gray-500 dark:focus:ring-gray-400 focus:border-transparent transition-colors placeholder:text-[14px] placeholder:font-normal placeholder:text-gray-400 dark:placeholder:text-[#6e7681] ${
                        error ? "border-red-500 dark:border-red-400" : "border-gray-300 dark:border-[#30363d]"
                    } ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
                />
                {error && (
                    <p className="text-red-500 dark:text-red-400 text-xs mt-1 font-medium">{error}</p>
                )}
            </div>
        </div>
    );
};

export default Textarea;
